<ul class="unstyled">
    <li>
        @if (personalDetails().gender === 'M') {
            <ap-content data-testid="salutation" key="{{ 'customer.display.male' | apKeyOverride: contentKeyMap() }}"></ap-content>
        }
        @if (personalDetails().gender === 'F') {
            <ap-content data-testid="salutation" key="{{ 'customer.display.female' | apKeyOverride: contentKeyMap() }}"></ap-content>
        }
        <span data-testid="customer-name">{{ personalDetails() | apCustomerName: partnerDetails() }}</span>
    </li>
    <li data-testid="first-names">
        <span>{{ personalDetails() | apPersonalName }}</span>
    </li>
</ul>
